var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgColumnChart = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.5 2.25C1.5 1.83579 1.16421 1.5 0.75 1.5C0.335786 1.5 0 1.83579 0 2.25V21.75C0 22.1642 0.335786 22.5 0.75 22.5H23.25C23.6642 22.5 24 22.1642 24 21.75C24 21.3358 23.6642 21 23.25 21H1.5V2.25Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.75 15C6.33579 15 6 15.3358 6 15.75C6 16.1642 6.33579 16.5 6.75 16.5H23.25C23.6642 16.5 24 16.1642 24 15.75C24 15.3358 23.6642 15 23.25 15H6.75Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M6 11.25C6 10.8358 6.33579 10.5 6.75 10.5H14.25C14.6642 10.5 15 10.8358 15 11.25C15 11.6642 14.6642 12 14.25 12H6.75C6.33579 12 6 11.6642 6 11.25Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.54545 6C6.24421 6 6 6.33579 6 6.75C6 7.16421 6.24421 7.5 6.54545 7.5H17.4545C17.7558 7.5 18 7.16421 18 6.75C18 6.33579 17.7558 6 17.4545 6H6.54545Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgColumnChart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/column-chart.7cdee04b91d5e073fec14ef467125e28.svg";